/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { NotificationSeverity } from './notifications';
export const systemIssueAlertSeverities = [
    NotificationSeverity.INFO,
    NotificationSeverity.WARNING,
    NotificationSeverity.ERROR,
];
//# sourceMappingURL=system-issues.js.map